import { goTo } from 'shared/lib';

import { SECTIONS_IDS } from 'constants/global';

export const headerNavButtonsData = [
  { text: 'О программе', onItemClick: () => goTo(SECTIONS_IDS.aboutProgram) },
  { text: 'Этапы', onItemClick: () => goTo(SECTIONS_IDS.stages) },
  { text: 'Менторы', onItemClick: () => goTo(SECTIONS_IDS.mentors) },
  { text: 'Условия', onItemClick: () => goTo(SECTIONS_IDS.conditions) },
  { text: 'Требования', onItemClick: () => goTo(SECTIONS_IDS.requirements) },
];
